const initial = {
    tournamentStarted: false,
    playerCounter: 0,
    players: [],
    rounds: [],
    totalRounds: 0,
    roundsCompleted: 0,
    champion: "",
    complete: false,
    playerNumberError: false,
  };
  
  export default initial;